import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setViewSettingsPresetInRedux } from "../../ViewerRedux/viewerSlice";
import { selectViewSettingsDetails } from "./viewSettingsSelectors";
import { ViewSettingsDialog } from "./ViewSettingsDialog";

export function ViewSettingsModal() {
  const dispatch = useAppDispatch();
  const details = useAppSelector(selectViewSettingsDetails);
  return details ? <ViewSettingsDialog details={details}
    onClose={() => dispatch(setViewSettingsPresetInRedux(null))} /> : null;
}
